module.exports = __webpack_public_path__ + "static/media/support-ico-3.f196bce8.png";